import { useState, useEffect } from "react";
import { selectCurrentEventId } from "modules/event/selectors";
import { useSelector } from "react-redux";
import { selectCurrentRoom } from "store/rooms";
import { useShuffleAttendees } from "modules/shuffleAttendees/hooks/useShuffleAttendees";
import { useShuffleAttendeesFirestore } from "modules/shuffleAttendees/hooks/useShuffleAttendeesFirestore";
import { ShuffleAttendeesDialog } from "../ShuffleAttendeesDialog";
import { ShuffleAttendeesCountdownDialog } from "../ShuffleAttendeesCountdownDialog";
import { ShuffleInProgress } from "../ShuffleInProgress";

export const ShuffleAttendeesContainer = () => {
  const currentEventId = useSelector(selectCurrentEventId);
  const currentTable = useSelector(selectCurrentRoom);
  const [targetGroupSize, setTargetGroupSize] = useState<number | null>(null);
  const {
    showShuffleAttendeesDialog,
    showShuffleAttendeesCountdown,
    showInitShuffleBanner,
  } = useShuffleAttendees();

  const { subscribeToShuffleEvents, unsubscribeToShuffleEvents } =
    useShuffleAttendeesFirestore();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (currentEventId) {
      subscribeToShuffleEvents(currentEventId);

      return () => {
        unsubscribeToShuffleEvents();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEventId, currentTable]);

  return (
    <>
      {showShuffleAttendeesDialog && (
        <ShuffleAttendeesDialog
          setTargetGroupSize={setTargetGroupSize}
          targetGroupSize={targetGroupSize}
        />
      )}
      {showShuffleAttendeesCountdown && <ShuffleAttendeesCountdownDialog />}
      {showInitShuffleBanner && currentEventId && (
        <ShuffleInProgress eventId={currentEventId} />
      )}
    </>
  );
};
